import { NoveltiesComponent } from './../components/novelties/novelties.component';
import { ArticleDetailComponent } from './../components/novelties/article-detail.component';
import { FileDetailComponent } from './../components/files/file-detail.component';
import { FileBrowseComponent } from './../shared/components/browse/file-browse.component';
import { EntityBrowseComponent } from './../shared/components/browse/entity-browse.component';
import { CategoryDetailComponent } from './../components/novelties/category-detail.component';
import { ConfirmationComponent } from './../shared/components/modal/confirmation/confirmation.component';
import { NewsDetailComponent } from './../components/novelties/news-detail.component';
import { AuthGuard } from './../shared/guards/auth.guard';

export const noveltiesRoutes = {
    path: 'novelties',
    data: {
        breadcrumbs: {
            label: 'Novinky',
            icon: 'articles'
        },
        state: 'novelties'
    },
    children: [
        {
            path: '',
            component: NoveltiesComponent
        },
        {
            path: 'articles/add',
            data: {
                breadcrumbs: {
                    label: 'Přidat článek'
                },
                state: 'article-add'
            },
            children: [
                {
                    path: '',
                    component: ArticleDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'articles-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'articles-media-browse'
                    },
                    outlet: 'browse'
                },
                {
                    path: 'entities/:url/:single',
                    component: EntityBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat'
                        },
                        state: 'articles-entities-browse'
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'categories/add',
            data: {
                breadcrumbs: {
                    label: 'Přidat kategorii'
                },
                state: 'category-add'
            },
            children: [
                {
                    path: '',
                    component: CategoryDetailComponent
                }
            ]
        },
        {
            path: 'articles/edit/:id',
            data: {
                breadcrumbs: {
                    label: 'Upravit článek'
                },
                state: 'article-edit'
            },
            children: [
                {
                    path: '',
                    component: ArticleDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'articles-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'articles-media-browse'
                    },
                    outlet: 'browse'
                },
                {
                    path: 'entities/:url/:single',
                    component: EntityBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat'
                        },
                        state: 'articles-entities-browse'
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'categories/edit/:id',
            data: {
                breadcrumbs: {
                    label: 'Upravit kategorii'
                },
                state: 'category-edit'
            },
            children: [
                {
                    path: '',
                    component: CategoryDetailComponent
                }
            ]
        },
        {
            path: 'articles-delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat článek'
                },
                state: 'articles-delete',
                apiUri: 'articles'
            },
            outlet: 'modal'
        },
        {
            path: 'categories-delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat kategorii'
                },
                state: 'category-delete',
                apiUri: 'categories'
            },
            outlet: 'modal'
        },
        {
            path: 'news/add',
            data: {
                breadcrumbs: {
                    label: 'Přidat novinku'
                },
                state: 'news-add'
            },
            children: [
                {
                    path: '',
                    component: NewsDetailComponent
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'news-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'news-media-browse',
                        isSingle: true,
                        imgOnly: true
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'news/edit/:id',
            children: [
                {
                    path: '',
                    component: NewsDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit novinku'
                        },
                        state: 'news-edit'
                    }
                },
                {
                    path: 'file/:id',
                    component: FileDetailComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Upravit soubor'
                        },
                        state: 'news-media-edit'
                    },
                    outlet: 'modal'
                },
                {
                    path: 'files',
                    component: FileBrowseComponent,
                    data: {
                        breadcrumbs: {
                            label: 'Vybrat soubor'
                        },
                        state: 'news-media-browse',
                        isSingle: true,
                        imgOnly: true
                    },
                    outlet: 'browse'
                }
            ]
        },
        {
            path: 'news-delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat novinku'
                },
                state: 'news-delete',
                apiUri: 'news'
            },
            outlet: 'modal'
        },
    ],
    canActivate: [AuthGuard]
};
